export enum SchedulePlayingTypeEnum {
  period = 'period',
  constant = 'constant',
  allday = 'allday',
}
